import { render } from "./EditDeal.vue?vue&type=template&id=80695baa"
import script from "./EditDeal.vue?vue&type=script&lang=js"
export * from "./EditDeal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__